import { render, staticRenderFns } from "./InfrastructureMain.vue?vue&type=template&id=0cc029f6&scoped=true"
import script from "./InfrastructureMain.vue?vue&type=script&lang=js"
export * from "./InfrastructureMain.vue?vue&type=script&lang=js"
import style0 from "./InfrastructureMain.vue?vue&type=style&index=0&id=0cc029f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc029f6",
  null
  
)

export default component.exports